import { MultilineText } from "@app/components/core/MultilineText/MultilineText"
import Button from "@app/components/move2Library/Button/Button"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { Modal, useModal } from "@tecreation/funnel-components"
import { ResponseError } from "@tecreation/js-state-react"
import { useEffect, useState } from "react"

import * as PACKAGE from "../../../package.json"
var version = PACKAGE.version

export function Timer({ onFinish, seconds }) {
	const [counter, setCounter] = useState(seconds)

	// Third Attempts

	useEffect(() => {
		if (counter == 0) {
			onFinish()
		}
		const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000)
		return () => clearInterval(timer)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [counter])

	return counter
}

export default function ErrorModal({ error }) {
	const modal = useModal()
	const _navigation = useCustomNavigation()

	const [showStack, setShowStack] = useState(false)

	return (
		<Modal>
			<Modal.Header>Something went wrong.</Modal.Header>

			<Modal.Body>
				<div className="f00 mb-5 flex flex-center">:(</div>

				<div>
					The application ran into a problem. We're just collection some error info, and then we'll restart for you. Or you can press the button below to
					proceed.
				</div>

				<div className="mt-4 flex flex-center">
					refresh in{" "}
					<Timer
						seconds={60}
						onFinish={() => {
							modal.hideModal()
							window.location.reload()
						}}
					/>{" "}
					seconds.
				</div>

				<div className="mt-4 relative">
					{showStack && (
						<div className="mt-3 errorBoundary absolute pt-3" style={{ position: "initial" }}>
							<h3 className="text-center semibold">Version: {version}</h3>
							<div style={{ backgroundColor: "rgba(206, 17, 38, 0.1)", color: "rgb(252, 207, 207)", letterSpacing: "2px" }} className="p-4 mt-5">
								<h3 className="mb-3">ERROR</h3>
								<div>
									{error instanceof ResponseError ? (
										<div>
											<div className="flex">
												<div style={{ width: "150px" }}>Endpoint:</div>
												<div>{error.response.url}</div>
											</div>
											<div className="flex">
												<div style={{ width: "150px" }}>StatusCode:</div>
												<div>{error.response.status}</div>
											</div>
											{error.params && (
												<div className="flex">
													<div style={{ width: "150px" }}>Parameters:</div>
													<div>{error.params}</div>
												</div>
											)}
											{error.sendedBody && (
												<div className="flex">
													<div style={{ width: "150px" }}>Body:</div>
													<div>
														<MultilineText>{JSON.stringify(error.sendedBody, null, 2)}</MultilineText>
													</div>
												</div>
											)}

											{error.response.data.traceToken && (
												<div className="flex">
													<div style={{ width: "150px" }}>ErrorMessage:</div>
													<div>{error.response.data.errorMessage}</div>
												</div>
											)}
											{error.response.data.traceToken && (
												<div className="flex">
													<div style={{ width: "150px" }}>TraceToken:</div>
													<div>{error.response.data.traceToken}</div>
												</div>
											)}
											<div className="flex">
												<div style={{ width: "150px" }}>Response:</div>
												<div>
													<MultilineText>{JSON.stringify(error.response.data, null, 2)}</MultilineText>
												</div>
											</div>
										</div>
									) : (
										<div>
											<MultilineText>{error.message}</MultilineText>
										</div>
									)}
								</div>

								<div className="mt-5 f-4">
									<h3 className="mb-3">Error Stacktrace</h3>
									<MultilineText>{error.stack}</MultilineText>
								</div>

								<div className="mt-5 f-4">
									<h3 className="mb-3">Component Stacktrace</h3>
									<MultilineText>{error.toString()}</MultilineText>
								</div>
							</div>
						</div>
					)}
				</div>
			</Modal.Body>

			<Modal.Footer>
				<div className="flex flex-center">
					<Button
						style="secondary"
						onClick={() => {
							modal.hideModal()
							window.location.reload()
						}}
					>
						Refresh
					</Button>
				</div>
				<div
					className="f6 absolute right-0"
					onClick={() => {
						setShowStack(!showStack)
					}}
					style={{ height: "100px", width: "100px" }}
				/>
			</Modal.Footer>
		</Modal>
	)
}
